module.exports = __webpack_public_path__ + "img/service2-2.3acc1fe0.jpg";